import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MediaModel } from '../../models/MediaModel';
import { MediaService } from '../../services/media.service';
import { MediaApiService } from '../../web-api-services/media.service';

@Component({
  selector: 'display-type-media',
  templateUrl: './display-type-media.component.html',
  styleUrls: ['./display-type-media.component.css'],
})
export class DisplayTypeMediaComponent implements OnInit {
  @Input() maxHeight: string = '20px';
  @Input() maxWidth: string = '20px';
  @Input() label: string = '';
  @Input() displayTooltip: boolean = true;
  baseCodeAide: string = 'upload.display-type-media.component';

  private _typeMediaId: number;
  @Input()
  set typeMediaId(value: number) {
    this._typeMediaId = value;
    this.loadMedias();
  }
  get typeMediaId(): number {
    return this._typeMediaId;
  }

  @Output() mediaClicked: EventEmitter<MediaModel> = new EventEmitter<MediaModel>();
  @Output() mediaClickedCount: EventEmitter<number> = new EventEmitter<number>();
  @Output() mediaAllClicked: EventEmitter<number> = new EventEmitter<number>();

  public medias: MediaModel[] = [];

  private mediaIdsClicked: boolean[] = [];
  private clickedCount: number = 0;

  constructor(
    public mediaService: MediaService,
    private mediaApiService: MediaApiService,
  ) {}

  ngOnInit() {}

  loadMedias() {
    this.mediaApiService.getMediasForType(this._typeMediaId).subscribe(medias => {
      this.medias = medias;
    });
  }

  mediaClick(media: MediaModel): boolean {
    if (!this.mediaIdsClicked[media.Id] === true) {
      this.mediaIdsClicked[media.Id] = true;
      this.clickedCount++;
      this.mediaClicked.emit(media);
      this.mediaClickedCount.emit(this.clickedCount);
      if (this.clickedCount == this.medias.length) {
        this.mediaAllClicked.emit(this.clickedCount);
      }
    }
    return true;
  }
}
